module.exports = __webpack_public_path__ + "img/notice_HKID.6af61127.svg";